<div class="modal fade" id="modalDeliveryComment" aria-hidden="true" aria-labelledby="exampleModalToggleLabel" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalToggleLabel">Phản hồi dữ liệu giao hàng</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="col-sm-12 d-flex flex-wrap mb-5 gap-5">
                    <div class="col-sm-12 d-flex gap-3">
                        <div>{{account.company_name}}</div>
                        <div>{{account.user_name}}</div>
                    </div>
                    <div class="col-sm-12">
                        <Ckeditor :editor="comment.editor" v-model="comment.editorData" :config="comment.editorConfig"></Ckeditor>
                    </div>
                </div>
                <div class="col-sm-12 d-flex justify-content-center gap-3">
                    <div class="col-sm-2">
                        <ButtonAddComponent label="Phản hồi" @click="sendCommentDelivery"></ButtonAddComponent>
                    </div>
                    <div class="col-sm-2">
                        <ButtonBackComponent label="Huỷ bỏ" @click="cancelComment"></ButtonBackComponent>
                    </div>
                </div>
            </div>
            <div class="modal-footer d-flex justify-content-center">
            </div>
        </div>
    </div>
</div>
